import React from "react";
var __jsx = React.createElement;
import getFromCdn from '@anm/helpers/getFromCdn';
import styled, { css } from 'styled-components';
var sizes = {
  micro: css(["width:8px;height:8px;"]),
  small: css(["width:14px;height:14px;"]),
  medium: css(["width:21px;height:21px;"]),
  large: css(["width:28px;height:28px;"]),
  large2: css(["width:38px;height:38px;"])
};

var getColor = function getColor(_ref) {
  var color = _ref.color;
  return {
    black: css(["background-image:url(", ");"], getFromCdn('images/loader-black.svg')),
    white: css(["background-image:url(", ");"], getFromCdn('images/loader.svg')),
    blue: css(["background-image:url(", ");"], getFromCdn('images/loader-blue.svg')),
    red: css(["background-image:url(", ");"], getFromCdn('images/loader-red.svg')),
    gray: css(["background-image:url(", ");"], getFromCdn('images/loader-gray.svg'))
  }[color];
};

export var LoaderWrapper = styled.div.withConfig({
  componentId: "crghqd-0"
})(["@keyframes spin{100%{transform:rotate(360deg);}}background-repeat:no-repeat;background-position:center;background-color:transparent;transform-origin:top right;animation:spin 0.5s infinite linear;margin:0 auto;background-size:contain;", ";", ";"], function (_ref2) {
  var size = _ref2.size;
  return sizes[size];
}, getColor);

var Loader = function Loader(props) {
  return __jsx(LoaderWrapper, props, __jsx("div", null));
};

export default Loader;